import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { waLink } from "../../data/content";

const LINKS = [
  { id: "servicios", label: "Servicios" },
  { id: "sobre-mi", label: "Sobre mí" },
  { id: "opiniones", label: "Opiniones" },
  { id: "faq", label: "Preguntas" },
  { id: "contacto", label: "Contacto" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setOpen(false);
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled ? "bg-[#05030A]/80 backdrop-blur-md border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <button data-testid="logo-home" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="text-left leading-tight">
          <span className="block font-serif text-xl text-[#F3EFE7] tracking-tight">Luz Sagrada</span>
          <span className="block text-[10px] uppercase tracking-[0.25em] text-[#C5A059]">Clarividencia</span>
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <button key={l.id} data-testid={`nav-${l.id}`} onClick={() => go(l.id)}
              className="text-sm text-white/70 hover:text-[#C5A059] transition-colors duration-300">
              {l.label}
            </button>
          ))}
          <a data-testid="header-whatsapp" href={waLink()} target="_blank" rel="noopener noreferrer"
            className="rounded-full border border-[#C5A059]/50 text-[#C5A059] px-5 py-2 text-sm hover:bg-[#C5A059] hover:text-[#05030A] transition-colors duration-300">
            WhatsApp
          </a>
        </nav>

        <button data-testid="mobile-menu-toggle" className="md:hidden text-[#F3EFE7]" onClick={() => setOpen((v) => !v)}>
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#05030A]/95 backdrop-blur-lg border-t border-white/5 px-5 py-6 flex flex-col gap-4">
          {LINKS.map((l) => (
            <button key={l.id} data-testid={`nav-mobile-${l.id}`} onClick={() => go(l.id)}
              className="text-left text-white/80 hover:text-[#C5A059] py-1">{l.label}</button>
          ))}
          <a href={waLink()} target="_blank" rel="noopener noreferrer"
            className="mt-2 text-center rounded-full bg-[#C5A059] text-[#05030A] py-3 font-medium">Escríbeme por WhatsApp</a>
        </div>
      )}
    </header>
  );
};
